export const getRoomsListFromBd = (state) => state.object.rooms